// extracted by mini-css-extract-plugin
module.exports = {"group_row":"group_row-HiJDp","group_name":"group_name-Ynv6D"};